<template>
  <v-container>
    <h2 class="text-h4">Details</h2>
    <v-list v-if="item" width="100%">
        <!--
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Name</v-list-item-subtitle>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        -->
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>ID</v-list-item-subtitle>
            <v-list-item-title>{{ item.id }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Monthly users</v-list-item-subtitle>
            <v-list-item-title>{{ item.stats.monthlyUsers }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Products updated</v-list-item-subtitle>
            <v-list-item-title>{{ item.productsUpdated }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Leadscores updated</v-list-item-subtitle>
            <v-list-item-title>{{ item.leadscoresUpdated }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Recommendations updated</v-list-item-subtitle>
            <v-list-item-title>{{ item.recommendationsUpdated }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>Events purged</v-list-item-subtitle>
            <v-list-item-title>{{ item.eventsPurged }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
</template>

<script>

  import { mapState } from "vuex";

  export default {
    name: 'DomainSchedule',
    data() {
      return {
      };
    },
    computed: {
      ...mapState('domains', ['item'])
    },
    methods: {
    },
    created() {
    }
  }
</script>
